module.exports = __webpack_public_path__ + "static/media/mungo_background.53a5aa0d.png";